export const ROUTE_PATH = '/clean/cleaner/calendar' as const
